// The states an appeal may put its transaction in, by kind: AppealRules in
// x-backend, and the database refuses any other. Not expired: core reopens an
// expired payin for late money, so an appeal to it would not stay put.
export const APPEAL_PAYIN_STATE = ['processed', 'refused', 'cancelled'];

export const APPEAL_PAYOUT_STATE = ['withdrawed', 'refused', 'withdraw_cancelled', 'cancelled'];

// Both kinds' together, for the grid's filter and before a kind is chosen.
export const APPEAL_CORRECT_STATE = ['processed', 'withdrawed', 'refused', 'withdraw_cancelled', 'cancelled'];

export const appealStatesFor = (kind) =>
    kind === 'payin' ? APPEAL_PAYIN_STATE : kind === 'payout' ? APPEAL_PAYOUT_STATE : APPEAL_CORRECT_STATE;
